import { useSelector } from 'react-redux'
import { selectedPartnershipSelector } from '../../../modules/selectors/partnerships'
import { keys } from '../../../helpers/common'
import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../constants/selectLists/platformList'

export default function useAvailablePlatforms() {
  const {
    facebook_ad_account: facebookAdAccount = {},
    google_ad_account: googleAdAccount = {},
    dv360_ad_account: dv360AdAccount = {},
    tiktok_ad_account: tiktokAdAccount = {}
  } = useSelector(selectedPartnershipSelector)

  const hasFacebook = !!keys(facebookAdAccount).length
  const hasGoogle = !!keys(googleAdAccount).length
  const hasDV360 = !!keys(dv360AdAccount).length
  const hasTikTok = !!keys(tiktokAdAccount).length

  return {
    [FACEBOOK_PLATFORM]: hasFacebook,
    [GOOGLE_PLATFORM]: hasGoogle,
    [DV_360_PLATFORM]: hasDV360,
    [TIKTOK_PLATFORM]: hasTikTok
  }
}
